import { z } from 'zod';
/**
 * Contrat du TÉLÉCHARGEMENT d'une SÉLECTION d'assets en une archive ZIP
 * (`POST /api/libraries/:id/assets/download`). Source unique de vérité front + back.
 *
 * La route renvoie un flux `application/zip` (pas de corps JSON) → seul le SCHÉMA DE
 * REQUÊTE est défini ici. Le corps porte une sélection NON VIDE d'ids d'assets,
 * PLAFONNÉE : construire l'archive lit chaque original sur disque (opération lente),
 * et une sélection énorme dégénérerait la requête ; on borne à `DOWNLOAD_SELECTION_MAX`.
 *
 * ⚠ PIÈGE ZOD v4 (boot crash) : ce schéma de REQUÊTE passe par
 * `z.toJSONSchema(schema, { target: 'draft-7' })` au démarrage (enregistrement de la
 * route Fastify). Un `.transform()` PERSONNALISÉ y LÈVE → l'API plante en boucle. On
 * n'en met AUCUN ici (uniquement `.array`/`.min`/`.max`/`.uuid` — représentables).
 * Garde anti-régression : `route-json-schema.test.ts` rejoue `z.toJSONSchema` dessus.
 */
/**
 * Plafond de la sélection téléchargeable en une archive. Une bibliothèque réelle
 * fait ~13 k médias ; 2000 originaux dans un ZIP restent raisonnables pour un seul
 * flux (le soft-cap protège d'une requête pathologique, pas d'un usage normal).
 */
export const DOWNLOAD_SELECTION_MAX = 2000;
/** Corps du téléchargement : une sélection NON VIDE d'ids d'assets (bornée). */
export const downloadSelectionRequestSchema = z.object({
    assetIds: z.array(z.uuid()).min(1).max(DOWNLOAD_SELECTION_MAX),
});
//# sourceMappingURL=download-selection.js.map